module.exports = __webpack_public_path__ + "static/media/BANNER_MOBILE.baae8a67.png";